import { useEffect } from "react";
// Replace with your Redux hooks
import { toast, ToastOptions } from "react-toastify";
import { useAppDispatch, useAppSelector } from "@/lib/store/hooks";
import { hideAlert } from "@/lib/store/features/alert/alertSlice";

const AlertHandler = () => {
  const dispatch = useAppDispatch();
  const { visible, message, type } = useAppSelector((state) => state.alert);

  useEffect(() => {
    if (visible) {
      // Configure toast styling
      const toastConfig: ToastOptions<unknown> = {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        closeButton: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: {
          backgroundColor:
            type === "success"
              ? "#4CAF50"
              : type === "info"
              ? "#FDF6E3"
              : "#F44336", // Green for success, red for error
          color: type === "info" ? "black" : "white",
          borderRadius: "8px",
        },
      };

      if (type === "success") {
        toast.success(message, {
          ...toastConfig,
          icon: <span className="text-white text-lg">✔</span>,
        });
      } else if (type === "error") {
        toast.error(message, {
          ...toastConfig,
          icon: <span className="text-white text-lg">⚠️</span>,
        });
      } else if (type === "info") {
        toast.info(message, {
          ...toastConfig,
          icon: <span className="text-white text-xl">🔔</span>
        });
      } else {
        toast.warn(message, toastConfig);
      }

      // Hide the alert after showing the toast
      dispatch(hideAlert());
    }
  }, [visible, message, type, dispatch]);

  return null; // This component only listens and triggers the toast
};

export default AlertHandler;
